import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useIntl } from 'react-intl';

import withOptional from '../../../../Utils/Posts/Form/withOptional';

export type TextFieldDefaultProps = TextFieldProps & {
  maxLength?: number;
  value: string | null | undefined;
};

// This TextField is preset for Forms
const TextFieldDefault = React.forwardRef(
  (
    {
      maxLength,
      value,
      error,
      helperText,
      label,
      required,
      slotProps,
      ...restProps
    }: TextFieldDefaultProps,
    ref: any,
  ) => {
    const intl = useIntl();
    const valuePlainText = value || '';
    const valuePlainTextLength = valuePlainText.length;

    const counter = intl.formatMessage(
      {
        id: 'TEXT_FIELD.LENGTH',
      },
      { length: valuePlainTextLength, maxLength },
    );

    const isLengthError = maxLength && valuePlainText && maxLength < valuePlainTextLength;

    const lengthErrorHelperText = intl.formatMessage(
      {
        id: 'TEXT_FIELD.LENGTH_ERROR_TEXT',
      },
      { length: value?.length, maxLength },
    );

    let newHelperText;

    if (helperText && !maxLength) {
      newHelperText = helperText;
    } else if (maxLength && helperText) {
      newHelperText = `${counter} - ${helperText}`;
    } else if (maxLength) {
      newHelperText = counter;
    }

    if (isLengthError) {
      newHelperText = `${counter} - ${lengthErrorHelperText}`;
    }

    return (
      <TextField
        ref={ref}
        variant="outlined"
        fullWidth
        value={valuePlainText}
        error={isLengthError || error}
        helperText={newHelperText}
        label={withOptional(label, required)}
        required={required}
        {...restProps}
        slotProps={{
          inputLabel: {
            shrink: true,
          },
          ...slotProps,
        }}
      />
    );
  },
);

TextFieldDefault.displayName = 'TextFieldDefault';

export default TextFieldDefault;
